export default __webpack_public_path__ + "static/media/team-image.1373b076.png";